import React, { useEffect, useRef, useState } from "react";
import "./ReceiptPrint.scss";
import { useNavigate, useParams } from "react-router-dom";
import { adminRequest } from "../../../utils/requestMethods";
import { MdArrowBack, MdPrint } from "react-icons/md";

import logo from "../../../assets/logo_prod.png";

const ReceiptPrint = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const printRef = useRef();
  const [invoice, setInvoice] = useState(null);
  const fetchInvoice = async () => {
    try {
      const response = await adminRequest.get(`/invoice/view/${id}`);
      setInvoice(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchInvoice();
  }, []);

  const handlePrint = () => {
    window.print();
  };

  if (!invoice) {
    return <div className="receiptPrintContainer">Loading...</div>;
  }

  return (
    <div className="receiptPrintContainer">
      <div className="topBar noPrint">
        <div className="leftSection">
          <button className="backBtn" onClick={() => navigate(-1)}>
            <MdArrowBack />
          </button>

          <h2>Invoice Receipt</h2>
        </div>

        <button className="printBtn" onClick={handlePrint}>
          <MdPrint />
          Print Receipt
        </button>
      </div>

      <div className="invoiceReceipt" ref={printRef}>
        <div className="topSerial">
          <p>
            Serial No:
            <span>{invoice.invoice_number}</span>
          </p>
        </div>

        <div className="receiptHeader">
          <div className="logoSection">
            <img src={logo} alt="college-logo" />
          </div>

          <div className="collegeDetails">
            <h2>Kantipur College of Management and Information Technology</h2>

            <p>Baneshwor, Kathmandu, Nepal</p>

            <p>Tel: 4479939</p>
          </div>
        </div>

        <div className="billTitle">
          <h3>Fee Receipt</h3>
        </div>

        <div className="invoiceMeta">
          <div className="metaRow">
            <div className="metaItem">
              <span>Name:</span>

              <p>{invoice.Student?.fullName}</p>
            </div>

            <div className="metaItem">
              <span>Semester:</span>

              <p>{invoice.semester}</p>
            </div>

            <div className="metaItem">
              <span>Program:</span>

              <p>{invoice.Course?.short_name}</p>
            </div>

            <div className="metaItem date">
              <span>Date:</span>

              <p>{invoice.invoice_date}</p>
            </div>
          </div>
        </div>

        <div className="invoiceTable">
          <table>
            <thead>
              <tr>
                <th>S.N</th>

                <th>DESCRIPTION</th>

                <th>Amount</th>

                <th>Remark</th>
              </tr>
            </thead>

            <tbody>
              {invoice.FeeInvoiceItems?.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>

                  <td>{item.title}</td>

                  <td>Rs. {item.amount}</td>

                  <td>{item.description || "-"}</td>
                </tr>
              ))}

              {invoice.discount_amount > 0 && (
                <tr>
                  <td>{invoice.FeeInvoiceItems?.length + 1}</td>
                  <td>Discount</td>
                  <td> (Rs. {invoice.discount_amount})</td>
                  <td>{invoice.discount_reason}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="totalSection">
          <div className="amountRow">
            <p>Total:</p>

            <span>
              Rs.
              {invoice.total_amount}
            </span>
          </div>

          <div className="amountRow">
            <p>Paid:</p>

            <span>
              Rs.
              {invoice.paid_amount}
            </span>
          </div>

          <div className="amountRow due">
            <p>Due:</p>

            <span>
              Rs.
              {invoice.due_amount}
            </span>
          </div>
        </div>

        <div className="bottomSection">
          <div className="receivedBy">
            <p>Received By</p>
          </div>

          <div className="officeSeal">
            <p>Office Seal</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReceiptPrint;
